
import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import { SignupFlowContext, SIGNUP_SUB_FLOW } from './signup-flow-provider';

export function useLogEnteredPage({
  Flow,
  SubFlow = SIGNUP_SUB_FLOW.NONE,
  Page,
}) {
  const { enteredPage } = useContext(SignupFlowContext);
  useEffect(() => {
    if (Page) {
      enteredPage({ Flow, SubFlow, Page });
    }
  }, [Flow, Page, SubFlow, enteredPage]);
}
export function LogEnteredPageOnRender({
  Flow,
  SubFlow,
  Page,
}) {
  useLogEnteredPage({ Flow, SubFlow, Page });
  return (<></>);
}

LogEnteredPageOnRender.propTypes = {
  Flow: PropTypes.string.isRequired,
  Page: PropTypes.string,
  SubFlow: PropTypes.string,
};

LogEnteredPageOnRender.defaultProps = {
  Page: null,
  SubFlow: null,
};

export function LogEnteredPageOnStep({
  StepsContext,
  Flow,
  SubFlow,
  PathToPage,
}) {
  const { currentPath } = useContext(StepsContext);
  const Page = currentPath && PathToPage ?
    PathToPage[currentPath] :
    currentPath;

  useLogEnteredPage({ Flow, SubFlow, Page });
  return <></>;
}

LogEnteredPageOnStep.propTypes = {
  StepsContext: PropTypes.shape({}).isRequired,
  PathToPage: PropTypes.shape({}),
  SubFlow: PropTypes.string,
  Flow: PropTypes.string.isRequired,
};

LogEnteredPageOnStep.defaultProps = {
  PathToPage: null,
  SubFlow: null,
};
